document.addEventListener("DOMContentLoaded", function () {
  formatAllData();

  var popup = document.getElementById("popup");
  var openPopupBtn = document.getElementById("openPopupBtn");
  var closePopupBtn = document.getElementById("closePopupBtn");

  if (openPopupBtn) {
    openPopupBtn.addEventListener("click", function () {
      popup.classList.remove("hidden");
    });
  }

  if (closePopupBtn) {
    closePopupBtn.addEventListener("click", function () {
      popup.classList.add("hidden");
    });
  }

  window.addEventListener("click", function (event) {
    if (event.target === popup) {
      popup.classList.add("hidden");
    }
  });

  // formatAllData();
  swipperPeopleTalksImages();
  swiperSocialProve();
});

function formatAllData() {
  const regEx = /&nbsp;/gm;

  const container = document.querySelector("main");
  const elements = [
    ...container.querySelectorAll("p"),
    ...container.querySelectorAll("li"),
    ...container.querySelectorAll("strong"),
    ...container.querySelectorAll("h1"),
    ...container.querySelectorAll("h2"),
    ...container.querySelectorAll("h3"),
    ...container.querySelectorAll("span"),
  ];

  const filteredElements = elements.filter((ele) => regEx.test(ele.innerHTML));

  filteredElements.forEach((ele) => {
    ele.innerHTML = ele.innerHTML.replace(regEx, " ");
  });
}

function swipperPeopleTalksImages() {
  if (document.querySelectorAll("#people_talk_about li").length > 2) {
    new Swiper("#people_talk_about .swiper", {
      loop: true,
      slidesPerView: 1,
      breakpoints: {
        400: {
          slidesPerView: 1,
        },
        700: {
          slidesPerView: 2,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
    });
  }
}

function swiperSocialProve() {
  new Swiper("#veja-clientes-falando .swiper", {
    slidesPerView: 'auto',
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}


function playVideo(element) {

  const video = element.nextElementSibling;
  element.classList.add("hidden");
  video.play();

  video.addEventListener("click",function() {
    video.pause();
    element.classList.remove("hidden");
  })
}